import { useTranslation } from "react-i18next"

export default function ProductInfoAvailability() {
    const { t } = useTranslation('productPage')
    return (
        <div className="pb-3">
            <strong className="d-block bi-collection">
                <span className="ps-2">{t('productInfo.availability')}</span>
            </strong>
            od ręki, duża ilość
        </div>
    )
}